



















import { computed, defineComponent, getCurrentInstance, onMounted, onUnmounted } from "@vue/composition-api";
import { EVENT_NAMES } from "@scrile/api-provider/dist";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import useAdditionalSources from "@/hooks/useAdditionalSources";
import useAuthUser from "@/hooks/useAuthUser";
import useDarkModeController from "@/hooks/useDarkModeController";
import useLocalFeatures from "@/hooks/useLocalFeatures";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import useSystemSettings from "@/hooks/useSystemSettings";
import useWatchMarkReadMessage from "@/hooks/useWatchMarkReadMessage";
import useWatchOpponentReadMessage from "@/hooks/useWatchOpponentReadMessage";
import useWebPushNotifications from "@/hooks/useWebPushNotifications";
import { ACTION_TYPES } from "@/store/const";
import { IS_BROWSER } from "@/lib/browserUtils";
import emitter from "@/lib/emitter";
import { isGetUserMediaSupported, isWebRTCSupported } from "@/lib/webrtcHelpers";
import config from "@/config";
import MainNavigationView from "@/components/MainNavigationView";
import NotificationBar from "@/components/NotificationBar";
import StatusNotificationBar from "@/components/StatusNotificationBar";
const LoginSignUpModal = () => import("@/components/LoginSignUpModal");
const BalanceManager = () => import("@/components/BalanceManager");
const PushManager = () => import("@/components/PushManager");
const PurchaseManager = () => import("@/components/PurchaseManager");
const CreatePost = () => import("@/components/CreatePost");
const ModalRefillBalance = () => import("@/components/ModalRefillBalance");
const CallController = () => import("@/components/CallController");
const AppointmentReminder = () => import("@/components/AppointmentReminder");
const ProfileVerifyingConfirm = () => import("@/components/ProfileVerifyingConfirm");
import "./styles/app.scss";
import "./styles/icons.scss";

if (IS_BROWSER) {
  document.title = config.siteName;
  import("@/lib/audioPlayer");
}

export default defineComponent({
  name: "App",
  components: {
    StatusNotificationBar,
    NotificationBar,
    MainNavigationView,
    LoginSignUpModal,
    BalanceManager,
    PushManager,
    PurchaseManager,
    CreatePost,
    ModalRefillBalance,
    CallController,
    AppointmentReminder,
    ProfileVerifyingConfirm,
  },
  setup() {
    const { getData } = useSystemSettings();
    const { authUser } = useAuthUser();
    const vm = getCurrentInstance();
    useWatchMarkReadMessage();
    useWatchOpponentReadMessage();
    const { init: initDarkMode } = useDarkModeController();
    const { init: initNSFWUserSetting } = useNSFWUserSettings();
    useAdditionalSources();
    useWebPushNotifications();
    const { isChangedFeatures, initFeatures } = useLocalFeatures();

    const setUserHandler = (payload: { user: User | null; authorities: string[] | null } | null) => {
      if (payload === null || payload.user === null) {
        if (authUser.value !== null) vm?.$router.push("/logout").then(() => location.reload());
      } else {
        vm?.$store.dispatch(ACTION_TYPES.LOGIN, payload);
      }
    };

    const featureCalling = computed(() => {
      return config.featureCalling && isWebRTCSupported() && isGetUserMediaSupported();
    });

    const featureAppointments = computed(() => {
      return config.featureAppointments;
    });

    emitter.on<any>(EVENT_NAMES.SET_USER, setUserHandler);

    onMounted(async () => {
      initNSFWUserSetting();
      initFeatures();
      await getData();
      initDarkMode();
    });

    onUnmounted(() => emitter.off<any>(EVENT_NAMES.SET_USER, setUserHandler));

    return {
      featureCalling,
      featureAppointments,
      authUser,
      isChangedFeatures,
    };
  },
});
